import { useState } from 'react';
import { fetchOccurrence } from '../../../api/fetchOccurence';
import type { Occurrence } from '../../../models/occurrence';
import type { TrackingPersona } from '../trackingUtils';

const useSelectedOccurrence = (occurrenceList: Occurrence[], persona: TrackingPersona) => {
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [fetchedOccurrence, setFetchedOccurrence] = useState<Occurrence | null>(null);

    const selectedOccurrence = selectedId
        ? (occurrenceList.find(item => item.id === selectedId) ??
          (fetchedOccurrence?.id === selectedId ? fetchedOccurrence : null))
        : null;
    const selectedInList = !!selectedId && occurrenceList.some(item => item.id === selectedId);

    const loadDetached = async (id: string) => {
        try {
            const loaded = await fetchOccurrence(id, persona);
            if (loaded) {
                setFetchedOccurrence(loaded);
            }
        } catch {
            setFetchedOccurrence(null);
        }
    };

    const openOccurrence = (id: string) => {
        setSelectedId(id);
        if (!occurrenceList.some(item => item.id === id)) {
            setFetchedOccurrence(null);
            loadDetached(id);
        }
    };

    const closeOccurrence = () => {
        setSelectedId(null);
        setFetchedOccurrence(null);
    };

    const refreshDetached = async <T>(result: T) => {
        if (selectedId && !selectedInList) {
            await loadDetached(selectedId);
        }
        return result;
    };

    return { selectedId, selectedOccurrence, openOccurrence, closeOccurrence, refreshDetached };
};

export default useSelectedOccurrence;
